<ngx-loading [show]="loading" style="z-index: 9999;"></ngx-loading>
<mat-accordion>
  <mat-expansion-panel hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="row-candidates">
          Nume: {{recommendation.user.name}}
        </div>
      </mat-panel-title>
      <mat-panel-description>{{recommendation.recomandation.recomandationBy.company.name}}</mat-panel-description>
    </mat-expansion-panel-header>
    <mat-divider></mat-divider>

    <p>Nume: {{recommendation.user.name}}</p>
    <p>Email: {{recommendation.user.email}}</p>
    <p>Recomandat de: {{recommendation.recomandation.recomandationBy.name}}</p>
    <p>Universitatea: {{recommendation.recomandation.recomandationBy.company.name}}</p>
    <p>Data recomandarii: {{recommendation.recomandation.created_at | date: 'dd-MM-yyyy HH:mm'}}</p>


    <mat-divider></mat-divider>
  </mat-expansion-panel>
</mat-accordion>

